<script setup>
const features = [
  { title: 'Kernel isolation', description: 'Each workload boots in its own microVM via Apple Hypervisor. No shared kernel. A compromised container can\'t escape to your Mac.' },
  { title: 'Devcontainer compatible', description: 'krate reads .devcontainer/devcontainer.json and docker-compose.yml verbatim. The same spec that works in VS Code Dev Containers and GitHub Codespaces works here.' },
  { title: 'Self-hostable', description: 'Solo: local on your Mac. Team: hosted on krate.sh. Enterprise: self-hosted on your own infrastructure.' },
  { title: 'Run any workload', description: 'Devcontainers, Docker containers, Docker compose, WebAssembly modules, and unikernels. Each in its own kernel-isolated microVM.' },
  { title: 'Policy as code', description: 'Declare what your team is allowed to run in a krate.policy file. Enforced at the daemon, audited locally, syncable across the org.' },
  { title: 'Real builds, real artifacts', description: 'krate build produces signed OCI artifacts you can pull from any standard registry. SLSA Level 3 attestation on the Enterprise tier.' },
]
</script>

<template>
  <section class="py-20 px-4">
    <div class="max-w-7xl mx-auto">
      <h2 class="text-4xl md:text-5xl font-bold text-center mb-12" style="color: var(--color-krate-dark-900);">What you get</h2>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div v-for="f in features" :key="f.title" class="rounded-lg p-6 border transition-colors hover:shadow-md" style="border-color: var(--color-krate-dark-200);">
          <h3 class="text-lg font-semibold mb-2" style="color: var(--color-krate-dark-900);">{{ f.title }}</h3>
          <p class="text-sm" style="color: var(--color-krate-dark-600);">{{ f.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
